export const environment = {
  production: false,
  maintenanceMode: false,
  SERVER_ROOT_URL: "https://dev-api.halcloudclinic.com/"
};
